<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">전자 계약</span>
            <span class="txt">
                발송한 계약서 내역을 확인하고, 자주 쓰는 템플릿(서식)을 등록하거나 수정할 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link
                        v-show="item.valid"
                        :class="{ on: $route.name == item.name }"
                        :to="{ ...item, params: { centerId } }"
                    >
                        {{ item.label }}
                    </router-link>
                </span>
            </div>

            <table class="com-table left" style="margin-top: 30px">
                <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                </colgroup>
                <tbody>
                    <tr>
                        <th>기간</th>
                        <td colspan="3">
                            <div class="com-calendar-wrap">
                                <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                                <div class="com-dash"><span class="dash">~</span></div>
                                <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                <select-form
                                    style="margin-left: 10px"
                                    :select-data="['오늘', '어제', '이번달', '지날달', '3개월', '6개월', '12개월']"
                                    :select-value="[
                                        'today',
                                        'yesterday',
                                        'thisMonth',
                                        'prevMonth',
                                        'threeMonth',
                                        'sixMonth',
                                        'year',
                                    ]"
                                    :selected-value="period"
                                    @update:set="(val) => periodc(val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>검색어</th>
                        <td colspan="3">
                            <div class="com-calendar-wrap">
                                <select-form
                                    style="margin-right: 10px"
                                    :select-data="['계약서명', '수신전화번호', '발송인명', '수신인명', '내용']"
                                    :select-value="[1, 2, 3, 4, 5, 6]"
                                    :selected-value="searchDivision"
                                    @update:set="(val) => setSearchDivision(val)"
                                ></select-form>
                                <input
                                    v-model="searchStr"
                                    placeholder=""
                                    type="text"
                                    style="width: 400px"
                                    v-on:keyup.enter="onEventSearch"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>계약서 유형</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == '' ? 'active' : ''}`"
                                    @click="onSearchMethod('')"
                                >
                                    전체
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'P' ? 'active' : ''}`"
                                    @click="onSearchMethod('P')"
                                >
                                    직원
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'M' ? 'active' : ''}`"
                                    @click="onSearchMethod('M')"
                                >
                                    회원
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'E' ? 'active' : ''}`"
                                    @click="onSearchMethod('E')"
                                >
                                    기타
                                </button>
                            </div>
                        </td>
                        <th>계약 상태</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchStatus == '' ? 'active' : ''}`"
                                    @click="onSearchStatus('')"
                                >
                                    전체
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchStatus == 'S' ? 'active' : ''}`"
                                    @click="onSearchStatus('S')"
                                >
                                    {{ 'S' | getContractSendStatus }}
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchStatus == 'R' ? 'active' : ''}`"
                                    @click="onSearchStatus('R')"
                                >
                                    {{ 'R' | getContractSendStatus }}
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchStatus == 'N' ? 'active' : ''}`"
                                    @click="onSearchStatus('N')"
                                >
                                    {{ 'N' | getContractSendStatus }}
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchStatus == 'C' ? 'active' : ''}`"
                                    @click="onSearchStatus('C')"
                                >
                                    {{ 'C' | getContractSendStatus }}
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchStatus == 'P' ? 'active' : ''}`"
                                    @click="onSearchStatus('P')"
                                >
                                    {{ 'P' | getContractSendStatus }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="bottom-btn" style="margin-top: 20px">
                <button class="com-btn" @click="onSearchList">검색</button>
                <button class="com-btn border-button general-button big" @click="onConditionInit">조건 초기화</button>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>발송내역</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count">
                            총
                            <span class="blue">{{ contractSendListPagingInfo.totalItems }}</span>
                            개
                        </span>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 245px" />
                        <col style="width: 100px" />
                        <col style="width: 145px" />
                        <col style="width: 285px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 220px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="
                                        contractSendListSortColumn == 'cs_cre_dt'
                                            ? contractSendListSortType == 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickSendDt"
                                >
                                    발송일시
                                </button>
                            </th>
                            <th>구분</th>
                            <th>계약 상태</th>
                            <th>계약서명</th>
                            <th>발송인</th>
                            <th>수신인</th>
                            <th>수신전화번호</th>
                            <th>
                        발송금액
                      </th>
                      <th>
                                서명기한
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <!--                                  <span class='tit'>Actual purchase price</span>-->
                                        <p class="txt">
                                            발송일을 기준으로 24시간 내에 계약이 완료되지 않을 시 '만료'로 변경됩니다.
                                        </p>
                                    </div>
                                </div>
                            </th>
                            <th>더보기</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, i) in contractSendList" :key="i">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="t.cst_id"
                                        v-model="selected"
                                        :value="i"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="t.cst_id"></label>
                                </div>
                            </td>
                            <td>{{ t.cs_cre_dt | timestampFilter2 }}</td>
                            <td>
                                {{ t.cs_contract_member_type | getContractMemberType }}
                            </td>
                      <td :style='"color: " + `${t.cs_status == "R" ? "#00C7E5" : (t.cs_status == "C" || t.cs_status == "N" ? "#f64444" : "black")}`'>
                                {{ t.cs_status | getContractSendStatus }}
                            </td>
                            <td>
                                <div style="width: 20vw">
                                    <div
                                        class="line-blind"
                                        style="text-decoration: underline; cursor: pointer"
                                        @click="onShowContract(i)"
                                    >
                                        {{ t.ct_contract_title }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{ t.c_center_name }}
                            </td>
                            <td>
                                {{ t.recipient_name }}
                            </td>
                            <td>
                                {{ t.recipient_phone | phoneNumberFilter }}
                            </td>
                            <td>
                        300원
                      </td>
                      <td>
                                {{ t.cs_deadline_dt | timestampFilter2 }}
                            </td>
                            <td>
                                <el-dropdown class="view-more-dropdown" @command="onClickViewMore">
                                    <el-button type="primary" trigger="click">...</el-button>
                                    <el-dropdown-menu>
                                        <el-dropdown-item
                                            :command="`${it.type + '-' + i}`"
                                            v-for="it in selectViewMore"
                                            :key="it.type"
                                        >
                                            {{ it.name }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </td>
                        </tr>
                        <tr v-if="contractSendList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload()">엑셀 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="[...sortTypeList]"
                            :select-value="[...sortTypeValueList]"
                            :selected-value="contractSendListPagingInfo.limit"
                            class="float-right"
                            @update:set="changeLimit"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="contractSendListPagingInfo.page"
                    :per-page="contractSendListPagingInfo.limit"
                    :total-rows="contractSendListPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>
        </template>

        <contract-preview-dlg
            v-if="contractPreviewPop"
            :show="contractPreviewPop"
            :templateSendId="selectedTemplateSendId"
            :close="handleCloseContractPreview"
        ></contract-preview-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import { Utils } from '@/assets/js/utils';
import ContractPreviewDlg from '../../../components/ContractPreviewDlg';
import XLSX from 'xlsx';
import { convertImgToDataURLviaCanvas } from '@/assets/js/common';

export default {
    name: 'ElectronicContractManage',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
        ContractPreviewDlg,
    },
    props: [],
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            centerId: 0,
            submenus: [
                { name: 'SettingElectronicContractManage', label: '계약 관리' },
                { name: 'SettingElectronicExternalDocument', label: '외부 문서' },
                { name: 'SettingElectronicTemplateManage', label: '템플릿 관리' },
                { name: 'SettingElectronicSignature', label: '서명' },
                { name: 'SettingElectronicSetting', label: '설정' },
            ],

            isLoading: false,

            contractSendList: [],
            contractSendListPagingInfo: { ...pagingInfo },
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            contractSendListSortColumn: 'cs_cre_dt',
            contractSendListSortType: 'DESC',

            selectedAll: false,
            selected: [],

            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            period: 'thisMonth', // 등록일 조회
            searchStr: '',
            searchDivision: 1,
            searchMethod: '',
            searchStatus: '',

            selectViewMore: [
                { type: 1, name: '업데이트' },
                { type: 2, name: '다운로드' },
                { type: 3, name: '발송취소' },
                { type: 4, name: '기한연장' },
            ],

            contractPreviewPop: false,
            selectedTemplateSendId: 0,
        };
    },
    methods: {
        // 초기화
        async init() {
            this.contractSendListPagingInfo.page = 1;
            this.centerId = parseInt(this.cId); // 센터id

            this.setSubMenu();

            this.onSearchList();
        },

        setSubMenu() {
            this.submenus[0].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[1].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[2].valid = this.isAllowed('ME', 6);
            this.submenus[3].valid = this.isAllowed('ME', 6);
            this.submenus[4].valid = this.isAllowed('ME', 6);
        },

        setSearchDivision(newValue) {
            this.searchDivision = newValue;
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().endOf('month').format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            return startDate;
        },

        handleCloseContractPreview() {
            this.contractPreviewPop = false;
        },

        onShowContract(index) {
            this.selectedTemplateSendId = this.contractSendList[index].cst_id;

            this.contractPreviewPop = true;
        },

        // Excel Download
        async excelDownload() {
            const { data } = await this.sendGetContractSendList();

            const excelDownloadArray = [];
            data.items.forEach((item) => {
                const temp = {};
                temp['발송일시'] = this.$options.filters.timestampFilter2(item.cs_cre_dt);
                temp['구분'] = this.$options.filters.getContractMemberType(item.cs_contract_member_type);
                temp['계약 상태'] = this.$options.filters.getContractSendStatus(item.cs_status);
                temp['계약서명'] = item.ct_contract_title;
                temp['발송인'] = item.c_center_name;
                temp['수신인'] = item.recipient_name;
                temp['수신전화번호'] = item.recipient_phone;
                temp['서명기한'] = this.$options.filters.timestampFilter2(item.cs_deadline_dt);

                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 30 },
                { wch: 20 },
                { wch: 30 },
                { wch: 30 },
                { wch: 30 },
                { wch: 30 },
                { wch: 30 },
                { wch: 30 },
            ];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Contract Send List');
            XLSX.writeFile(wb, `Contract Send List ${new Date().toLocaleDateString().toString()}.xlsx`);
        },

        // 한 페지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.contractSendListPagingInfo.limit = val;
            this.onSearchList();
        },

        periodc(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
        },

        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.contractSendList) {
                    this.selected.push(parseInt(i));
                }
            }
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },
        // Paging Param 설정
        setPageParams(data) {
            this.contractSendListPagingInfo.totalPages = data.meta.totalPages;
            this.contractSendListPagingInfo.page = data.meta.currentPage;
            this.contractSendListPagingInfo.totalItems = data.meta.totalItems;
            this.contractSendListPagingInfo.itemCount = data.meta.itemCount;
        },

        sendGetContractSendList() {
            let params = {
                startDate: moment(this.startDate).format('YYYYMMDD'),
                endDate: moment(this.endDate).format('YYYYMMDD'),
                searchDivision: this.searchDivision,
                searchStr: this.searchStr,
                searchMethod: this.searchMethod,
                searchStatus: this.searchStatus,
                contractSendListSortColumn: this.contractSendListSortColumn,
                contractSendListSortType: this.contractSendListSortType,
                ...this.contractSendListPagingInfo,
            };

            return api.get(`/admin/api/center/contract/list/sender/${this.centerId}`, {
                params,
            });
        },

        onSearch() {
            this.contractSendListPagingInfo.page = 1;
            this.onSearchList();
        },

        async onSearchList() {
            try {
                this.isLoading = true;

                const { data } = await this.sendGetContractSendList();
                this.setPageParams(data);
                this.contractSendList = data.items;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        onSearchDivision(type) {
            this.searchDivision = type;
        },

        onSearchMethod(type) {
            this.searchMethod = type;
        },

        onSearchStatus(type) {
            this.searchStatus = type;
        },

        // 이용권명 컬럼 클릭시
        onClickSendDt() {
            this.contractSendListSortColumn = 'cs_cre_dt';
            if (this.contractSendListSortType === '' || this.contractSendListSortType === 'DESC') {
                this.contractSendListSortType = 'ASC';
            } else {
                this.contractSendListSortType = 'DESC';
            }
            this.onSearchList();
        },

        getTemplate(templateSendId) {
            return api.get(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/send/${templateSendId}`
            );
        },

        getElementItemHtml(item, senderImageRawData, recipientImageRawData) {
            let html = ``;
            let index = 0;

            html += `
              <div class='contract-content-info'>
                    <div class='contract-title-input' style='margin-bottom: 20px; background-color: white'>
                        ${item.e_contract_title}
                    </div>
                    <div class='contract-info-title'>수신인 정보</div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>이름</div>
                        <div class='contract-info-sub-title'>${item.recipientName}</div>
                    </div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>연락처</div>
                        <div class='contract-info-sub-title'>${item.recipientPhone}</div>
                    </div>`;
            if (item.centerContractId > 0 && item.centerProdId > 0) {
                const ticketInfo = JSON.parse(item.ticketInfo);
                if (ticketInfo && ticketInfo.length > 0) {
                    html += `<div class='contract-info-title'>이용권 정보</div>`;

                    ticketInfo.map((t) => {
                        html +=
                            `
                            <div class='ticket-container'>
                                <div class='ticket-box'>
                                    <div class='ticket-box-title'>` +
                            t.title +
                            `</div>
                                    <div class='ticket-box-info'>
                                        <div style='flex: 1'>
                                            ` +
                            t.period +
                            `
                                        </div>
                                        <div>
                                            ` +
                            (t.price + '원') +
                            `
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    });
                }
            }

            html += `<div class='contract-info-title'>약관</div>`;

            if (item.templateInfo) {
                item.templateInfo.map((it, i) => {
                    html += `<div style='padding: 10px 10px 0 10px'>`;

                    const content = it.content.replace(new RegExp('\n', 'g'), '<br>');

                    if (it.type == 1) {
                        html += `
                        <div>
                            <div class='contract-info-sub-title' style='display: flex'>
                                <div style='flex: 1;'>${it.title}</div>
                            </div>
                            <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>
                        </div>
                      `;
                    } else {
                        html += `
                        <div style='display: flex'>
                            <div style='flex: 1;'>
                                <div class='contract-info-sub-title' style='display: flex'>
                                    <div style='flex: 1;'>${it.title}</div>
                                </div>
                                <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>`;

                        it.options.map((jt, j) => {
                            html += `
                            <div style='display: flex; align-items: center; margin-top: 10px'>
                                <div class='com-check'>
                                    <input
                                        :id='agree-check-${index}-${i}-${j}'
                                        name='check-c1'
                                        ` + (jt.checked ? "checked" : "") + `
                                        type='checkbox'
                                        disabled
                                    />
                                    <label :for='agree-check-${index}-${i}-${j}' class='agree-option'></label>
                                </div>
                                <div class='agree-option-input'>${jt.title}</div>
                            </div>
                          `;
                        });

                        html += `
                            </div>
                        </div>`;
                    }

                    html += `</div>`;
                });
            }

            html +=
                `
                    <div style='display: flex'>
                        <div class='contract-info-title' style='flex: 1;'>${this.$options.filters.dateFormatFilter2(
                            item.sendTime
                        )}</div>
                        <div style='width: 300px; margin-top: 40px;'>
                            <div style='display: flex; align-items: center'>
                                <div class='contract-info-person'>수신인</div>
                                <img class='contract-info-signature' src='` +
                recipientImageRawData +
                `' />
                            </div>
                            <div style='display: flex; align-items: center; margin-top: 10px;'>
                                <div class='contract-info-person'>발신인</div>
                                <img class='contract-info-signature' src='` +
                senderImageRawData +
                `' />
                            </div>
                        </div>
                    </div>
                  </div>
              `;

            return html;
        },

        getElementHtml(list, callback) {
            const item = list[0];
            let senderImageRawData = item.senderSignImageUrl;
            let recipientImageRawData = item.recipientSignImageUrl;
            // const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);
            // callback(html);

            convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                senderImageRawData = imageRawData;
                convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                    recipientImageRawData = imageRawData;

                    const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);

                    callback(html);
                });
            });
        },

        getPDFContent(index, returnBuffer = false) {
            return Promise.all([this.getTemplate(this.contractSendList[index].cst_id)]).then((response) => {
                if (response && response.length > 0) {
                    const list = response[0].data;

                    let element = document.createElement('div');
                    element.style.padding = '20px';

                    this.getElementHtml(list, (html) => {
                        element.innerHTML = html;

                        let filename = this.contractSendList[index].ct_contract_title + '.pdf';
                        if (this.contractSendList[index].recipient_name) {
                          filename = this.contractSendList[index].ct_contract_title + '(' + this.contractSendList[index].recipient_name + ').pdf';
                        }

                        let opt = {
                            filename: filename,
                            enableLinks: true,
                            image: { type: 'jpeg', quality: 0.98 },
                            html2canvas: {
                                scale: 3,
                                y: -40,
                                scrollY: 0,
                                useCORS: true,
                                width: 800,
                                height: 1130,
                                letterRendering: true,
                            },
                            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                        };

                        if (returnBuffer) {
                            return html2pdf().from(element).set(opt).output();
                        } else {
                            return html2pdf().from(element).set(opt).save();
                        }
                    });
                }
            });
        },

        async onClickViewMore(command) {
            const data = command.split('-');
            const index = data[1];
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'P') {
                alert('기간만료된 계약서입니다.');
                return;
            }
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'R') {
                alert('이미 완료된 계약서입니다.');
                return;
            }
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'N') {
                alert('이미 거절된 계약서입니다.');
                return;
            }

            if (data[0] == 1) {
                this.onSearchList();
            } else if (data[0] == 2) {
                this.getPDFContent(index);
            } else if (data[0] == 3) {
                const index = data[1];
                if (this.contractSendList[index].cs_status == 'S') {
                    if (confirm('계약서 발송을 취소 하시겠습니까?')) {
                        const data = await api.put(
                            `/admin/api/center/contract/send/cancel/${this.contractSendList[index].cst_id}`
                        );
                        if (data) {
                            alert('취소 요청이 접수되었습니다.');
                            this.onSearchList();
                        }
                    }
                } else if (this.contractSendList[index].cs_status == 'C') {
                    alert('이미 취소된 계약서입니다.');
                } else {
                    alert('이미 발송된 계약서입니다.');
                }
            } else if (data[0] == 4) {
                const index = data[1];
                if (this.contractSendList[index].cs_status == 'S') {
                    if (
                        confirm(
                            '서명기한을 연장할 경우 연장된 기한으로 해당 계약서가 자동으로 재전송됩니다. 진행하시겠습니까?'
                        )
                    ) {
                        const data = await api.put(
                            `/admin/api/center/contract/expand/deadline/${this.contractSendList[index].cst_id}/1`
                        );
                        if (data) {
                            alert('계약서가 연장된 기한으로 재발송되었습니다.');
                            this.onSearchList();
                        }
                    }
                } else if (this.contractSendList[index].cs_status == 'C') {
                    alert('이미 취소된 계약서입니다.');
                } else {
                    alert('이미 발송된 계약서입니다.');
                }
            }
        },

        // 검색어 입력 처리
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }

            this.onSearch();
        },

        onConditionInit() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = 'thisMonth';
            this.searchStr = '';
            this.searchDivision = 1;
            this.searchMethod = '';
            this.searchStatus = '';
        },

        // 페지 변경 Handler
        handlerPagenation(event) {
            this.contractSendListPagingInfo.page = event;
            this.onSearchList();
        },
    },
};
</script>
<style lang="scss"></style>
